import { get } from '@lumapps/constants';

const Config = get();

export const DEFAULT_LANGUAGE = Config.defaultLanguage;

/**
 *  Mappings from deprecated lang code to corrected lang code (format v1)
 *  @see https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
 */
export const LANG_CODE_MIGRATION: Record<string, string> = {
    br: 'pt_br',
    jp: 'ja',
    iw: 'he',
    in: 'id',
};
